import { Lock, Clock, PauseCircle, CheckCircle2 } from "lucide-react";
import { fmtDate } from "../lib/api";

const STATES = {
  open: [Clock, "border-emerald-500/40 text-emerald-300", (i) => `Consegna aperta fino al ${fmtDate(i.lock_at)} (5 minuti prima della prima partita)`],
  live: [Lock, "border-amber-500/40 text-amber-300", () => "Consegna chiusa · giornata in corso: i punti si calcolano a fine dell'ultima partita"],
  suspended: [PauseCircle, "border-orange-500/40 text-orange-300", (i) => `Calcolo punti sospeso: ${i.postponed} partita/e rinviata/e, in attesa del recupero`],
  scored: [CheckCircle2, "border-blue-500/40 text-blue-300", () => "Giornata conclusa · punti assegnati"],
};

export const RoundStatus = ({ info }) => {
  if (!info) return null;
  const [Icon, cls, text] = STATES[info.status] || STATES.live;
  return (
    <div className={`flex items-center gap-3 rounded-xl border bg-[#121824] px-4 py-3 sm:px-5 sm:py-4 text-xs sm:text-sm ${cls}`} data-testid={`round-status-${info.status}`}>
      <Icon size={18} className="shrink-0" />
      <span>{text(info)}</span>
    </div>
  );
};
